export const testIds = {
  appConfig: {
    container: 'ac-container',
    provider: 'ac-provider',
    openAIKey: 'ac-openai-api-key',
    customizeOpenAIApiPath: 'ac-customize-openai-api-path',
    openAIApiPath: 'ac-openai-api-path',
    openAIOrganizationID: 'ac-openai-api-organization-id',
    openAIUrl: 'ac-openai-api-url',
    anthropicKey: 'ac-anthropic-api-key',
    anthropicUrl: 'ac-anthropic-api-url',
    vectorEnabled: 'ac-vector-enabled',
    qdrantAddress: 'ac-qdrant-address',
    qdrantSecure: 'ac-qdrant-secure',
    qdrantApiKey: 'ac-qdrant-api-key',
    grafanaVectorApiUrl: 'ac-grafana-vector-api-url',
    model: 'ac-vector-model',
    submit: 'ac-submit-form',
    basicAuthUsername: 'ac-basic-auth-username',
    basicAuthPassword: 'ac-basic-auth-password',
  },
  mainPage: {
    container: 'main-page-container',
  },
  models: {
    container: 'models-container',
  },
  mcpTools: {
    container: 'mcp-tools-container',
    disabled: 'mcp-tools-disabled',
    loading: 'mcp-tools-loading',
    error: 'mcp-tools-error',
    empty: 'mcp-tools-empty',
    list: 'mcp-tools-list',
    toolItem: 'mcp-tools-tool-item',
    toolName: 'mcp-tools-tool-name',
    toolDescription: 'mcp-tools-tool-description',
  },
};
